import { render, staticRenderFns } from "./OsListDescarte.vue?vue&type=template&id=63103e05&"
import script from "./OsListDescarte.vue?vue&type=script&lang=js&"
export * from "./OsListDescarte.vue?vue&type=script&lang=js&"
import style0 from "./OsListDescarte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports